{
  "sales_agents": {
    "login": "Login"
  },
  "quoting": {
    "request_quote": "Request Quote",
    "order_completed": "Order Completed"
  },
  "analytics": {
    "title": "Contribution profit trend"
  }
}
